import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";

export const freewayDetectExample: TemplateDefinition = {
  mode: "detect",
  slug: "freeway-detect-example",
  version: 1,
  title: "Traffic monitoring",
  description: "Count vehicles at scale",
  subdescription: "Point out every car and truck across a busy freeway.",
  thumbnailUuid: BASE_ASSETS.oaklandFreewayExample.uuid,
  assets: [BASE_ASSETS.oaklandFreewayExample],
  detect: {
    mediaUuid: BASE_ASSETS.oaklandFreewayExample.uuid,
    categories: ["car", "truck"],
    config: {
      output: "point",
    },
  },
};
